import AlertComponent from "slotworks/components/alert/alert-component";
import Contract from "slotworks/utils/contracts/contract";

export class VAlertComponent extends AlertComponent {

    public error(messageId: string, fatal: boolean = false): Contract<void> {
        return new Contract<void>((resolve) => {
            const message = this.getMessage(messageId);

            V.API.Dialog.showErrorDialog(message, () => {
                if (fatal) {
                    V.API.Core.launchLobby();
                    return;
                }

                resolve(null);
            });
        });
    }
}
